<template>
  <div class="stepper-box">
    <div class="stepper-wrapper pb-5 pb-lg-4">
      <div class="text-right pt-3 mr-3">
        <button
          v-if="currentStep.next"
          class="btn btn-highlighted"
          @click="logout()"
        >
          Odhlásiť <font-awesome-icon :icon="['fa', 'sign-out-alt']" />
        </button>
      </div>
      <div class="text-center pb-4">
        <h4 class="text-highlighted pb-4 pt-3">
          {{ currentStep.title }}
        </h4>
        <div class="px-2">
          {{ heading }}
        </div>
      </div>
      <div class="top">
        <br />
        <div
          class="divider-line"
          :style="{
            width: `${(100 / steps.length) * (steps.length - 1) - 10}%`
          }"
        ></div>
        <div class="steps-wrapper">
          <template v-if="topButtons">
            <div
              v-if="currentStep.index > 0"
              class="stepper-button-top previous"
              @click="backStep()"
            >
              <i class="material-icons">keyboard_arrow_left</i>
            </div>
          </template>
          <template v-for="(step, index) in steps">
            <div
              :class="['step', isStepActive(index, step)]"
              :key="index"
              :style="{ width: `${100 / steps.length}%` }"
            >
              <div class="circle">
                <i class="material-icons md-18" v-if="step.completed">done</i>
                <i class="material-icons step-number md-18" v-else>{{
                  step.number
                }}</i>
              </div>
              <div class="step-title">
                <h4>{{ step.title }}</h4>
                <h5 class="step-subtitle">{{ step.subtitle }}</h5>
              </div>
            </div>
          </template>
          <div
            v-if="topButtons"
            :class="[
              'stepper-button-top next',
              !canContinue ? 'deactivated' : ''
            ]"
            @click="submit()"
          >
            <i class="material-icons">keyboard_arrow_right</i>
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <transition
        :enter-active-class="enterAnimation"
        :leave-active-class="leaveAnimation"
        mode="out-in"
      >
        <!--If keep alive-->
        <keep-alive v-if="keepAliveData">
          <component
            ref="child"
            :is="steps[currentStep.index].component"
            :clickedNext="nextButton[currentStep.name]"
            @can-continue="proceed"
            @change-next="changeNextBtnValue"
            :current-step="currentStep"
          ></component>
        </keep-alive>
        <!--If not show component and destroy it in each step change-->
        <component
          ref="child"
          v-else
          :is="steps[currentStep.index].component"
          :clickedNext="nextButton[currentStep.name]"
          @can-continue="proceed"
          @change-next="changeNextBtnValue"
          :current-step="currentStep"
        ></component>
      </transition>
    </div>
    <div class="bottom pl-md-5">
      <div class="row w-100">
        <div class="col-12 col-md-4 left" v-if="!isMobile || currentStep.back">
          <div
            v-if="currentStep.index > 0 && currentStep.back"
            class="stepper-button previous float-md-left"
            @click="backStep()"
          >
            <i class="material-icons">keyboard_arrow_left</i>
            <span>Späť / znovu vyplniť dotazník</span>
          </div>
        </div>
        <div class="col-12 col-md-8 right" v-if="currentStep.next">
          <div
            class="stepper-button next float-md-right"
            :class="!canContinue ? 'deactivated' : ''"
            @click="submit()"
          >
            <span>{{ finalStep ? "Dokončiť" : "Pokračovať" }}</span>
            <font-awesome-icon
              v-if="loading"
              icon="spinner"
              class="ml-2"
              spin
            />
            <i v-else class="material-icons">keyboard_arrow_right</i>
          </div>
          <div
            class="stepper-button later float-md-right mr-md-3"
            @click="sendLink()"
          >
            <span>Pokračovať neskôr</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// https://www.npmjs.com/package/vue-stepper

import {token} from "@/store/modules/onboarding";

export default {
  props: {
    heading: {
      type: String,
      default: ""
    },
    locale: {
      type: String,
      default: "en"
    },
    topButtons: {
      type: Boolean,
      default: false
    },
    steps: {
      type: Array,
      default: function() {
        return [
          {
            icon: "mail",
            name: "first",
            title: "Sample title 1",
            subtitle: "Subtitle sample"
          },
          {
            icon: "report_problem",
            name: "second",
            title: "Sample title 2",
            subtitle: "Subtitle sample"
          }
        ];
      }
    },
    keepAlive: {
      type: Boolean,
      default: true
    },
    reset: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentStep: {},
      previousStep: {},
      nextButton: {},
      canContinue: false,
      finalStep: false,
      keepAliveData: this.keepAlive,
      isMobile: false,
      loading: false
    };
  },
  mounted() {
    if (token()) {
      this.$store.dispatch("onboarding/getCurrentStep").then(response => {
        this.activateStep(parseInt(response.data.result.step) - 1, true);
      });
    }
    this.setMobile();
    this.$nextTick(function() {
      window.addEventListener("resize", this.setMobile);
    });
  },
  destroyed() {
    window.removeEventListener("resize", this.setMobile);
  },
  computed: {
    enterAnimation() {
      if (this.currentStep.index < this.previousStep.index) {
        return "animated quick fadeInLeft";
      } else {
        return "animated quick fadeInRight";
      }
    },
    leaveAnimation() {
      if (this.currentStep.index > this.previousStep.index) {
        return "animated quick fadeOutLeft";
      } else {
        return "animated quick fadeOutRight";
      }
    },
    currentStepTmp() {
      return this.$store.state.onboarding.currentStep;
    }
  },
  methods: {
    isStepActive(index) {
      if (this.currentStep.index === index) {
        return "activated";
      } else {
        return "deactivated";
      }
    },
    activateStep(index, back = false) {
      if (this.steps[index]) {
        this.previousStep = this.currentStep;
        this.currentStep = {
          name: this.steps[index].name,
          title: this.steps[index].title,
          back: this.steps[index].back,
          next: this.steps[index].next,
          submit: this.steps[index].submit,
          index: index
        };

        this.finalStep = index + 1 === this.steps.length;

        // if (!back) {
        //   this.$emit("completed-step", this.previousStep);
        // }

        if (index === 0 && token()) {
          this.currentStep.next = true;
        }

        for (let i = 0; i < index; i++) {
          this.$emit("completed-step", this.steps[i]);
        }
      }
      this.$emit("active-step", this.currentStep);
    },
    nextStepAction() {
      this.nextButton[this.currentStep.name] = true;
      if (this.canContinue) {
        if (this.finalStep) {
          this.$emit("stepper-finished", this.currentStep);
        }
        const currentIndex = this.currentStep.index + 1;

        this.activateStep(currentIndex);
        window.scrollTo(0, 0);
      }
      this.canContinue = false;
      this.$forceUpdate();
    },
    submit() {
      if (this.currentStep.submit) {
        if (typeof this.$refs.child.submit === "function") {
          this.$refs.child.submit();
        } else {
          this.$refs.child.$children[0].submit();
        }
      } else {
        this.nextStep();
      }
    },
    nextStep() {
      if (!this.$listeners || !this.$listeners["before-next-step"]) {
        this.nextStepAction();
      }

      this.canContinue = false;

      this.$emit(
        "before-next-step",
        { currentStep: this.currentStep },
        (next = true) => {
          this.canContinue = true;
          if (next) {
            this.nextStepAction();
          }
        }
      );
    },
    backStep() {
      this.$emit("clicking-back");
      const currentIndex = this.currentStep.index - 1;
      if (currentIndex >= 0) {
        this.activateStep(currentIndex, true);
      }
      window.scrollTo(0, 0);
    },
    proceed(payload) {
      this.canContinue = payload.value;
    },
    changeNextBtnValue(payload) {
      this.nextButton[this.currentStep.name] = payload.nextBtnValue;
      this.$forceUpdate();
    },
    init() {
      // Initiate stepper
      this.activateStep(0);
      this.steps.forEach(step => {
        this.nextButton[step.name] = false;
      });
    },
    setMobile() {
      const width = document.body.clientWidth || document.width;
      this.isMobile = width < 600;
    },
    sendLink() {
      this.$store.dispatch("onboarding/sendLink");
    },
    logout() {
      this.$store.dispatch("onboarding/logout");
    }
  },

  watch: {
    reset(val) {
      if (!val) {
        return;
      }

      this.keepAliveData = false;

      this.init();
      this.previousStep = {};

      this.$nextTick(() => {
        this.keepAliveData = this.keepAlive;
        this.$emit("reset", true);
      });
    },
    currentStepTmp() {
      if (this.currentStepTmp === null) {
        this.activateStep(0, true);
      }
    }
  },

  created() {
    this.init();
  }
};
</script>

<style scoped>
/* fallback */
@font-face {
  font-family: "Material Icons";
  font-style: normal;
  font-weight: 400;
  src: local("Material Icons"), local("MaterialIcons-Regular"),
    url(https://fonts.gstatic.com/s/materialicons/v17/2fcrYFNaTjcS6g4U3t-Y5ZjZjT5FdEJ140U2DJYC3mY.woff2)
      format("woff2");
}

.material-icons {
  font-family: "Material Icons";
  font-weight: normal;
  font-style: normal;
  font-size: 24px;
  line-height: 1;
  letter-spacing: normal;
  text-transform: none;
  display: inline-block;
  white-space: nowrap;
  word-wrap: normal;
  direction: ltr;
  -webkit-font-feature-settings: "liga";
  -webkit-font-smoothing: antialiased;
}
</style>
